<script>
import DataTableChipColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableChipColumn.vue';
import StatementType from 'Modules/contacard/reports/statements/components/StatementType';

export default {
  name: 'StatementTypeColumn',
  extends: DataTableChipColumnVue,
  data: (vm) => ({
    status: vm.handleStatus(StatementType),
  }),
};
</script>
